import React from "react";
import RenewSubscriptionScreen from "../components/RenewSubscriptionScreen";

const PaymentSuccess = () => {
	return <RenewSubscriptionScreen title={"Merci ! Votre commande d'abonnement est bien finalisée."} />;
};

export default PaymentSuccess;
